import axios from "axios";

export const getFeaturedEvents = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredevents/getevents/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const getEventsNotFeatured = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredevents/geteventsnotfeatured/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const addFeaturedEvents = (careersClientId, events) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredevents/addevents/" +
        encodeURIComponent(careersClientId),
      events
    )
    .then((res) => res.data);
};

export const deleteFeaturedEvent = (eventId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredevents/deleteevent/" +
        encodeURIComponent(eventId)
    )
    .then((res) => res);
};

export const getFeaturedEventSettings = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredevents/geteventsettings/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const addFeaturedEventSettings = (settings) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredevents/addeventsettings",
      settings
    )
    .then((res) => res);
};
